import { useCallback } from 'react';

export const useFirstErrorFocus = () => {
    return useCallback((validationErrors = {}) => {
        const firstErrorKey = Object.keys(validationErrors).find((key) => validationErrors[key]);
        if (!firstErrorKey) return;

        document.getElementById(firstErrorKey)?.focus();
    }, []);
};
